import { Person } from 'entities/person/model/types';
import { FC } from 'react';
import { formatPhoneNumber } from 'shared/lib/string';
import { InfoFieldCard } from 'shared/ui/cards/infoFieldCard';
import { Flex } from 'shared/ui/flex';

export const PersonFieldsRowInfo: FC<{ person?: Person | null }> = ({
	person,
}) => {
	return (
		<Flex $gap="8px" $justify="space-between">
			{person && (
				<>
					<InfoFieldCard
						title="Телефон"
						variant={'default'}
						styles={{ padding: '8px 25px' }}
					>
						{formatPhoneNumber(person.phone)}
					</InfoFieldCard>

					<Flex $gap="8px">
						<InfoFieldCard
							title="Кол-во визитов"
							variant={'default'}
							styles={{ textAlign: 'center' }}
						>
							{person?.visits}
						</InfoFieldCard>
						<InfoFieldCard
							title="Кол-во отмен"
							variant={'default'}
							styles={{ textAlign: 'center' }}
						>
							{person?.cancelled}
						</InfoFieldCard>
					</Flex>
				</>
			)}
		</Flex>
	);
};
